//---------FORMULARIO FIGMA-----------------

import React, { useState, useEffect, useContext } from 'react';
import {Select, MenuItem, InputLabel, Typography, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField, InputAdornment, Divider, Button } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import { Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircle';
import RemoveIcon from '@mui/icons-material/RemoveCircle';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { AntTabs, AntTab } from './tabs_style';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español

dayjs.locale('es'); // Establece el idioma local a español

export default function ResumenSeparacion() {
    const [analista, setAnalista] = React.useState('');
    const [filtroRevisor, setFiltroRevisor] = React.useState('');

    const handleAnalistaChange = (event) => {
        setAnalista(event.target.value);
    };

    const handleFiltroRevisorChange = (event) => {
        setFiltroRevisor(event.target.value);
    };
    const textFieldStyles = {
        '& .MuiOutlinedInput-root': { color: 'black' },
        '& .MuiInputLabel-root': { color: 'black' },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' }
    };

    const [tabIndex, setTabIndex] = useState(4);
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const [rows, setRows] = useState([
        {
            id: 1,
            inicio: null,
            final: null,
            errors: {
                inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
                final: { fechaVacia: false, invalidFormat: false, cleared: false }
            }
        }
    ]);

    const [dias, setDias] = useState(0);
    const [meses, setMeses] = useState(0);
    const [años, setAños] = useState(0);

    const handleAddRow = () => {
        const newRow = {
            id: rows.length + 1,
            inicio: null,
            final: null,
            errors: {
                inicio: { fechaVacia: false, invalidFormat: false, cleared: false },
                final: { fechaVacia: false, invalidFormat: false, cleared: false }
            }
        };
        setRows([...rows, newRow]);
    };

    const handleRemoveRow = (id) => {
        if (rows.length > 1) {
            if (id !== 1) {
                const updatedRows = rows.filter(row => row.id !== id);
                // Recalcula los números de fila
                const recalculatedRows = updatedRows.map((row, index) => ({ ...row, id: index + 1 }));
                setRows(recalculatedRows);
                calculateDurations(recalculatedRows);
            }
        }
    };


    const calculateDurations = (rows) => {
        let totalDias = 0;
        let totalMeses = 0;
        let totalAños = 0;

        rows.forEach(row => {
            if (row.inicio && row.final) {
                const start = dayjs(row.inicio, "DD/MM/YYYY");
                const end = dayjs(row.final, "DD/MM/YYYY");

                if (start.isValid() && end.isValid() && !end.isBefore(start)) {
                    const duration = end.diff(start, 'day');
                    totalDias += duration;
                    totalMeses += end.diff(start, 'month');
                    totalAños += end.diff(start, 'year');
                }
            }
        });

        setDias(totalDias);
        setMeses(totalMeses);
        setAños(totalAños);
    };

    const handleDateChange = (rowId, field, date) => {
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                const newErrors = { ...row.errors[field] };

                if (!date) {
                    newErrors.fechaVacia = true;
                    newErrors.invalidFormat = false;
                } else if (!dayjs(date, "DD/MM/YYYY").isValid()) {
                    newErrors.fechaVacia = false;
                    newErrors.invalidFormat = true;
                } else {
                    newErrors.fechaVacia = false;
                    newErrors.invalidFormat = false;

                    if (field === 'final' && row.inicio && dayjs(date, "DD/MM/YYYY").isBefore(dayjs(row.inicio, "DD/MM/YYYY"))) {
                        newErrors.invalidRange = true;
                    } else if (field === 'inicio' && row.final && dayjs(row.final, "DD/MM/YYYY").isBefore(dayjs(date, "DD/MM/YYYY"))) {
                        row.errors.final.invalidRange = true;
                    } else {
                        newErrors.invalidRange = false;
                        row.errors.final.invalidRange = false;
                    }
                }

                return {
                    ...row,
                    [field]: date,
                    errors: {
                        ...row.errors,
                        [field]: newErrors
                    }
                };
            }
            return row;
        });

        setRows(updatedRows);
        calculateDurations(updatedRows);
    };

    const handleClearDate = (rowId, field) => {
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                return {
                    ...row,
                    [field]: null,
                    errors: {
                        ...row.errors,
                        [field]: { ...row.errors[field], cleared: true }
                    }
                };
            }
            return row;
        });

        setRows(updatedRows);
        calculateDurations(updatedRows);
    };

    const handleBlurDate = (rowId, field) => {
        const updatedRows = rows.map(row => {
            if (row.id === rowId) {
                const newErrors = { ...row.errors[field] };
                if (!row[field]) {
                    newErrors.fechaVacia = true;
                    newErrors.invalidFormat = false;
                }
                return {
                    ...row,
                    errors: {
                        ...row.errors,
                        [field]: newErrors
                    }
                };
            }
            return row;
        });

        setRows(updatedRows);
        calculateDurations(updatedRows);
    };

    const validarSoloNumeros = (event) => {
        // Solo permitir números y el punto decimal
        event.target.value = event.target.value.replace(/[^0-9.]/g, '');

        // Asegurarse de que solo haya un punto decimal
        if (event.target.value.split('.').length > 2) {
            event.target.value = event.target.value.replace(/\.+$/, "");
        }

        // Formatear con comas
        const parts = event.target.value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        event.target.value = parts.join('.');
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras, espacios y letras con acentos
        event.target.value = event.target.value.replace(/[^A-Za-zÁÉÍÓÚÜáéíóúü\s]/g, '');

        // Convertir a mayúsculas
        event.target.value = event.target.value.toUpperCase();
    };

    const today = dayjs();

    // Estado de los datepicker
    const [solicitanteNacimiento, setSolicitanteNacimiento] = React.useState(null);
    const [solicitanteNacimientoErrors, setSolicitanteNacimientoErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    const [fechaSoli, setFechaSoli] = React.useState(null);
    const [fechaSoliErrors, setFechaSoliErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    const [fechaCese, setFechaCese] = React.useState(null);
    const [fechaCeseErrors, setFechaCeseErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    const [fechaRetiro, setFechaRetiro] = React.useState(null);
    const [fechaRetiroErrors, setFechaRetiroErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    const [fechaAnalisis, setFechaAnalisis] = React.useState(null);
    const [fechaAnalisisErrors, setFechaAnalisisErrors] = React.useState({
        fechaVacia: false,
        invalidFormat: false,
        cleared: false
    });

    function CustomDatePickerNacimiento({ label, selectedDate, setSelectedDate, errors, setErrors, ...props }) {
        const today = dayjs();

        React.useEffect(() => {
            if (errors.cleared) {
                setSelectedDate(null);
                const timeout = setTimeout(() => {
                    setErrors(prev => ({ ...prev, cleared: false }));
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [errors.cleared, setSelectedDate, setErrors]);

        const handleDateChange = (date) => {
            if (!date) {
                setErrors({ fechaVacia: true, invalidFormat: false, cleared: false });
            } else if (!dayjs(date, "DD/MM/YYYY").isValid()) {
                setErrors({ fechaVacia: false, invalidFormat: true, cleared: false });
            } else {
                setErrors({ fechaVacia: false, invalidFormat: false, cleared: false });
                setSelectedDate(date);
            }
        };

        const handleBlur = () => {
            if (!selectedDate) {
                setErrors(prev => ({ ...prev, fechaVacia: true, invalidFormat: false }));
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        onAccept={handleDateChange}
                        label={label}
                        slotProps={{
                            field: { clearable: true, onClear: () => setErrors(prev => ({ ...prev, cleared: true })) },
                            textField: {
                                helperText: errors.fechaVacia ? `Seleccione la ${label}` : errors.invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: errors.fechaVacia || errors.invalidFormat,
                                onKeyDown: handleKeyDown,
                                onBlur: handleBlur
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {errors.cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>
        );
    }

    function CustomDatePickerTabla({ rowId, field, label, selectedDate, errors, ...props }) {
        const today = dayjs();

        useEffect(() => {
            if (errors.cleared) {
                const timeout = setTimeout(() => {
                    setRows(rows.map(row => {
                        if (row.id === rowId) {
                            return {
                                ...row,
                                errors: {
                                    ...row.errors,
                                    [field]: { ...row.errors[field], cleared: false }
                                }
                            };
                        }
                        return row;
                    }));
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [errors.cleared, rowId, field]);

        const handleDateChangeWrapper = (date) => {
            handleDateChange(rowId, field, date);
        };

        const handleBlurWrapper = () => {
            handleBlurDate(rowId, field);
        };

        const handleKeyDown = (event) => {
            event.preventDefault();
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        onAccept={handleDateChangeWrapper}
                        label={label}
                        slotProps={{
                            field: { clearable: true, onClear: () => handleClearDate(rowId, field) },
                            textField: {
                                helperText: errors.fechaVacia ? `Seleccione la ${label}` :
                                    errors.invalidFormat ? "Formato de fecha incorrecto" :
                                        (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" :
                                            errors.invalidRange ? "La Fecha Final no puede ser menor que la Fecha Inicio" : null),
                                error: errors.fechaVacia || errors.invalidFormat || errors.invalidRange,
                                onKeyDown: handleKeyDown,
                                onBlur: handleBlurWrapper
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {errors.cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>
        );
    }

    const [errors, setErrors] = React.useState({});

    const handleBlur = (event) => {
        const fieldName = event.target.id;
        const fieldValue = event.target.value;
        let errorMessage = '';

        const fieldNamesToMessages = {
            noexpediente: 'Ingrese el número de expediente',
            nohojatrabajo: 'Ingrese el número de hoja de trabajo',
            nombrecorrecto: 'Ingrese el nombre correcto',
            cotizacionesMacot: 'Ingrese cotizaciones según macot',
            rebajas: 'Ingrese rebajas',
            montoBeneficio: 'Ingrese monto del beneficio',
            montoResumen: 'Ingrese monto del resumen',
            diferencia: 'Ingrese diferencia',
            montoRetiroOficio: 'Ingrese monto retiro oficio',
            interesRetiroOficio: 'Ingrese interés al retiro oficio',
            cotRo: 'Ingrese Cot después del RO',
            cotdelAdelante: 'Ingrese Cot- del en adelante',
            interesRebajas: 'Ingrese intereses de las rebajas',
            tasaMes: 'Ingrese tasa del mes',
            intRo: 'Ingrese Int después del RO',
            solicitanteNacimiento: 'Ingrese la fecha de nacimiento'
        };

        if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
            if (fieldValue.length < 1) {
                errorMessage = fieldNamesToMessages[fieldName];
            }
        }

        setErrors(prevErrors => ({
            ...prevErrors,
            [fieldName]: errorMessage
        }));
    };

    return (
        <>
            <Container>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <h2><b>Resumen Separación Del Sistema</b></h2>
                </div>
            </Container>
            <Container>
                <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Paper square>
                        <AntTabs
                            value={tabIndex}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            TabIndicatorProps={{
                                style: { display: 'none' }, // O también puedes usar display: 'none' aquí
                            }}
                        >
                            <AntTab label="Resumen" />
                            <AntTab label="Tabla De Interés" />
                            <AntTab label="Tasas Por Año" />
                            <AntTab label="Monto Del Beneficio" />
                            <AntTab label="Datos" />
                            <AntTab label="Cálculos" />
                        </AntTabs>
                    </Paper>
                </Box>

                <Box mt={3}>
                    {/* Contenido de la pestaña actual */}
                    {tabIndex === 0 && navigate('/Separaciones/Resumen')}
                    {tabIndex === 1 && navigate('/Separaciones/TablaDeInteres')}
                    {tabIndex === 2 && navigate('/Separaciones/Tasas')}
                    {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficio')}
                    {tabIndex === 4}
                    {tabIndex === 5 && navigate('/Separaciones/Calculos')}
                </Box>
            </Container>
            <Box marginTop={2} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Stack direction="row">
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="noexpediente"
                                        label="No. Expediente"
                                        variant="outlined"
                                        error={Boolean(errors.noexpediente)}
                                        onBlur={handleBlur}
                                        onInput={validarSoloNumeros}
                                        helperText={errors.noexpediente}
                                    //sx={textFieldStyles}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="nohojatrabajo"
                                        label="No. Hoja Trabajo"
                                        variant="outlined"
                                        onInput={validarSoloNumeros}
                                        error={Boolean(errors.nohojatrabajo)}
                                        onBlur={handleBlur}
                                        helperText={errors.nohojatrabajo}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="nombresistema"
                                        label="Nombre (Según Sistema)"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="nombrecorrecto"
                                        label="Nombre Correcto"
                                        variant="outlined"
                                        onInput={validarSoloLetras}
                                        inputProps={{ maxLength: 80 }}
                                        error={Boolean(errors.nombrecorrecto)}
                                        onBlur={handleBlur}
                                        helperText={errors.nombrecorrecto}
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="nocotizante"
                                        label="No. Cotizante"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="identidad"
                                        label="No. Identidad"
                                        variant="outlined"
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="ramo"
                                        label="Ramo"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" marginTop={1}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="dependencia"
                                        label="Dependencia"
                                        variant="outlined"
                                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>

            <Box marginTop={3} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <CustomDatePickerNacimiento
                                        id='solicitanteNacimiento'
                                        label="Fecha De Nacimiento"
                                        selectedDate={solicitanteNacimiento}
                                        setSelectedDate={setSolicitanteNacimiento}
                                        errors={solicitanteNacimientoErrors}
                                        setErrors={setSolicitanteNacimientoErrors}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <CustomDatePickerNacimiento
                                        id='fechaSoli'
                                        label="Fecha De Solicitud"
                                        selectedDate={fechaSoli}
                                        setSelectedDate={setFechaSoli}
                                        errors={fechaSoliErrors}
                                        setErrors={setFechaSoliErrors}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <CustomDatePickerNacimiento
                                        id='fechaCese'
                                        label="Fecha De Cese De Labores"
                                        selectedDate={fechaCese}
                                        setSelectedDate={setFechaCese}
                                        errors={fechaCeseErrors}
                                        setErrors={setFechaCeseErrors}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <CustomDatePickerNacimiento
                                        id='fechaRetiro'
                                        label="Fecha Del Retiro De Oficio"
                                        selectedDate={fechaRetiro}
                                        setSelectedDate={setFechaRetiro}
                                        errors={fechaRetiroErrors}
                                        setErrors={setFechaRetiroErrors}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <CustomDatePickerNacimiento
                                        id='fechaAnalisis'
                                        label="Fecha Del Análisis"
                                        selectedDate={fechaAnalisis}
                                        setSelectedDate={setFechaAnalisis}
                                        errors={fechaAnalisisErrors}
                                        setErrors={setFechaAnalisisErrors}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="cotizacionesMacot"
                                        label="Cotizaciones Según Macot"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.cotizacionesMacot)}
                                        onBlur={handleBlur}
                                        helperText={errors.cotizacionesMacot}

                                    />                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="rebajas"
                                        label="Rebajas"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.rebajas)}
                                        onBlur={handleBlur}
                                        helperText={errors.rebajas}

                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="montoBeneficio"
                                        label="Monto Del Beneficio"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.montoBeneficio)}
                                        onBlur={handleBlur}
                                        helperText={errors.montoBeneficio}

                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="montoResumen"
                                        label="Monto Del Resumen"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.montoResumen)}
                                        onBlur={handleBlur}
                                        helperText={errors.montoResumen}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="diferencia"
                                        label="Diferencia"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.diferencia)}
                                        onBlur={handleBlur}
                                        helperText={errors.diferencia}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="montoRetiroOficio"
                                        label="Monto del Retiro de Oficio (RO)"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.montoRetiroOficio)}
                                        onBlur={handleBlur}
                                        helperText={errors.montoRetiroOficio}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="interesRetiroOficio"
                                        label="Intereses Al Retiro de Oficio"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.interesRetiroOficio)}
                                        onBlur={handleBlur}
                                        helperText={errors.interesRetiroOficio}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="cotRo"
                                        label="Cot Después Del RO al 12/05/2014"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.cotRo)}
                                        onBlur={handleBlur}
                                        helperText={errors.cotRo}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="intRo"
                                        label="Int- Después Del RO al 12/05/2014"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.intRo)}
                                        onBlur={handleBlur}
                                        helperText={errors.intRo}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="cotdelAdelante"
                                        label="Cot- Del 13/05/2014 En Adelante"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.cotdelAdelante)}
                                        onBlur={handleBlur}
                                        helperText={errors.cotdelAdelante}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="interesRebajas"
                                        label="Intereses De Las Rebajas"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.interesRebajas)}
                                        onBlur={handleBlur}
                                        helperText={errors.interesRebajas}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="tasaMes"
                                        label="Tasa Del Mes"
                                        onInput={validarSoloNumeros}
                                        variant="outlined"
                                        InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                        error={Boolean(errors.tasaMes)}
                                        onBlur={handleBlur}
                                        helperText={errors.tasaMes}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
            </Box>

            <Box marginTop={3} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Stack direction="row" alignItems="center" marginBottom={2}>
                            <IconButton onClick={handleAddRow} title="Agregar Celda">
                                <AddIcon style={{ color: 'green', fontSize: '30px' }} />
                            </IconButton>
                            <Typography variant="h6"><strong>Períodos</strong></Typography>
                        </Stack>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>#</strong></TableCell>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Inicio</strong></TableCell>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Final</strong></TableCell>
                                        <TableCell style={{ textAlign: 'center', fontSize: 16 }}><strong>Eliminar</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell style={{ textAlign: 'center', fontSize: 16 }}>
                                                <label><strong>{row.id}</strong></label>
                                            </TableCell>
                                            <TableCell>
                                                <CustomDatePickerTabla
                                                    rowId={row.id}
                                                    field='inicio'
                                                    label="Fecha Inicio"
                                                    selectedDate={row.inicio}
                                                    errors={row.errors.inicio}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <CustomDatePickerTabla
                                                    rowId={row.id}
                                                    field='final'
                                                    label="Fecha Final"
                                                    selectedDate={row.final}
                                                    errors={row.errors.final}
                                                />
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                <IconButton onClick={() => handleRemoveRow(row.id)} title="Remover Celda" disabled={row.id === 1}>
                                                    <RemoveIcon style={{ color: row.id === 1 ? 'gray' : 'red', fontSize: '30px' }} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {/*<Box display="flex" justifyContent="center" alignItems="center" marginTop={4}>
                            <Stack direction="row" spacing={2}>
                                <TextField label="Días" variant="filled" value={dias} InputProps={{ readOnly: true }} />
                                <TextField label="Meses" variant="filled" value={meses} InputProps={{ readOnly: true }} />
                                <TextField label="Años" variant="filled" value={años} InputProps={{ readOnly: true }} />
                            </Stack>
                                </Box>*/}
                        <Box display="flex" justifyContent="center" alignItems="center" marginTop={4}>
                            <Stack direction="row" spacing={2}>
                                <Box display="flex" alignItems="center">
                                    <Typography marginRight={1} fontWeight="bold">Días:</Typography>
                                    <TextField
                                        variant="filled"
                                        value={dias}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { textAlign: 'center' }
                                        }}
                                        inputProps={{
                                            style: { textAlign: 'center' }
                                        }}
                                        sx={{ width: '80px' }}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography marginRight={1} fontWeight="bold">Meses:</Typography>
                                    <TextField
                                        variant="filled"
                                        value={meses}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { textAlign: 'center' }
                                        }}
                                        inputProps={{
                                            style: { textAlign: 'center' }
                                        }}
                                        sx={{ width: '80px' }}
                                    />
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <Typography marginRight={1} fontWeight="bold">Años:</Typography>
                                    <TextField
                                        variant="filled"
                                        value={años}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { textAlign: 'center' }
                                        }}
                                        inputProps={{
                                            style: { textAlign: 'center' }
                                        }}
                                        sx={{ width: '80px' }}
                                    />
                                </Box>
                            </Stack>
                        </Box>
                    </CardContent>
                </Card>
            </Box>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', marginTop: 3 }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                    <Button
                        variant="contained"
                        startIcon={<SaveIcon style={{ fontSize: 40 }} />}
                        size='large'
                        style={{ width: '200px', height: '50px', backgroundColor: "#AD8401"}}
                    >
                        Guardar
                    </Button>
                    <Button
                        variant="contained"
                        size='large'
                        startIcon={<EditIcon style={{ fontSize: 40 }} />}
                        style={{ width: '200px', height: '50px', backgroundColor: "#AD8401"}}
                    >
                        Modificar
                    </Button>
                    <Button
                        variant="contained"
                        size='large'
                        startIcon={<DeleteForeverIcon style={{ fontSize: 40 }} />}
                        style={{ width: '200px', height: '50px', backgroundColor: "#AD8401"}}
                    >
                        Eliminar
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Box
                        p={2}
                        borderRadius={3}
                        maxWidth={390}
                        boxShadow={1}
                        style={{
                            background: 'linear-gradient(to bottom right, #dddddd, #ffffff)'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <AccountCircleIcon style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                            <strong>Analista:</strong>
                            <FormControl style={{ marginLeft: 10, minWidth: 200 }}>
                                <Select
                                    labelId="analista-label"
                                    value={analista}
                                    onChange={handleAnalistaChange}
                                    variant='standard'
                                    displayEmpty
                                    renderValue={(value) => value || 'Seleccionar Analista'}
                                >
                                    <MenuItem value="Diana Reyes">Diana Reyes</MenuItem>
                                    <MenuItem value="Iven Yojana Gonzalez">Iven Yojana Gonzalez</MenuItem>
                                    <MenuItem value="Odilia Cruz">Odilia Cruz</MenuItem>
                                    <MenuItem value="Lili Aguilera">Lili Aguilera</MenuItem>
                                    <MenuItem value="Alexa Fuentes">Alexa Fuentes</MenuItem>
                                </Select>
                            </FormControl>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <SupervisedUserCircleIcon style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                            <strong>Filtro Revisor:</strong>
                            <FormControl style={{ marginLeft: 10, minWidth: 200 }}>
                                <Select
                                    labelId="filtro-revisor-label"
                                    value={filtroRevisor}
                                    onChange={handleFiltroRevisorChange}
                                    variant='standard'
                                    displayEmpty
                                    renderValue={(value) => value || 'Seleccionar Filtro'}
                                >
                                    <MenuItem value="Alexa Fuentes">Alexa Fuentes</MenuItem>
                                    <MenuItem value="Clementina Molina">Clementina Molina</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </div>
            </div>
        </>
    )
}

